<template>
  <div class="common-card supplier-list-wrapper">
    <staff-password-edit :user-info="userInfo" />
    <reset-email-by-admin
      url="/suppliers"
      @reset-data="refetchData"
      role="供應商"
      :reset-data="resetData"
    />
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon class="mr-50" icon="fa-solid fa-truck-field" />
            供應商
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex mobile-w100 flex-wrap mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋"
          />
          <!--  <b-button
            variant="primary"
            class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
            @click="$bvModal.show('modal-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          > -->
          <b-button
            class="mobile-w100 mr-sm-1 mb-1 mb-sm-0"
            :to="{ name: 'supplier-create' }"
            v-if="ability.can('create', 'setting_suppliers') && !isStaff"
          >
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增供應商</b-button
          >
          <b-button
            class="mobile-w100"
            @click="exportReport"
            v-if="ability.can('export', 'setting_suppliers') && !isStaff"
          >
            <feather-icon class="" icon="plusIcon" size="18"></feather-icon
            >導出記錄</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refSupplierListTable"
          class="position-relative"
          :items="fetchSuppliers"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(locked)="data">
            <feather-icon
              v-if="data.item.locked"
              icon="LockIcon"
              size="18"
              class="mr-50 text-danger"
            />
          </template>

          <template #cell(bank)="data">
            {{ data.item.bank && data.item.bank.name }}
          </template>
          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(is_active)="data">
            <feather-icon
              v-if="data.item.is_active"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                suppliersList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>


              <b-dropdown-item
                v-if="(ability.can('view_detail', 'staff_suppliers'))"
                :to="{
                  name: 'staff-supplier-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item>
              

              <b-dropdown-item
                v-if="
                  ability.can('unlock', 'setting_suppliers') && data.item.locked && !isStaff
                "
                @click="cleanLocked(data.item.id)"
              >
                <feather-icon icon="LockIcon" />
                <span class="align-middle ml-50">解封</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'setting_suppliers') && !isStaff"
                :to="{
                  name: 'supplier-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('reset_email', 'setting_suppliers') && !isStaff"
                @click="triggerResetEmailModal(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">重設電郵</span>
              </b-dropdown-item>

              

              <b-dropdown-item
                v-if="ability.can('reset_password', 'setting_suppliers') && !isStaff"
                @click="triggerResetPasswordModal(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改密碼</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'setting_suppliers') && !isStaff"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useSuppliersList from "./useSuppliersList";
import supplierStoreModule from "../supplierStoreModule";
import StaffPasswordEdit from "../../staff/staffs-list/StaffPasswordEdit.vue";
import ResetEmailByAdmin from "@/views/user/resetEmailbyAdmin.vue";
import router from "@/router";

export default {
  components: {
    // ModalFilter,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    StaffPasswordEdit,
    ResetEmailByAdmin,
  },
  data() {
    return {
      userInfo: {
        id: null,
        name: null,
        password: null,
        password_confirmation: null,
      },
      resetData: { id: 0, email: "", vertification_code: "" },
    };
  },
  // 是否是員工埋數用頁面
  computed: {
    isStaff() {
      return this.$route.name === "staff-supplier-list";
    },
  },
  methods: {
    triggerResetEmailModal(item) {
      this.resetData = item;
      this.$bvModal.show("modal-reset-email-admin");
    },
    cleanLocked(id) {
      this.$store
        .dispatch("app/cleanLocked", { id })
        .then((response) => {
          this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
          this.refetchData();
        })
        .catch((error) => {
          this.$swal({
            text: error.response.data.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    exportReport() {
      this.$swal({
        title: "確定導出Excel?",
        showCancelButton: true,
        confirmButtonText: "下載",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.$store
            .dispatch("supplier/exportSuppliers", {
              perPage: this.perPage,
              page: this.currentPage,
              sortBy: this.sortBy,
              sortDesc: this.isSortDirDesc,
            })
            .then((response) => {
              // create file link in browser's memory
              const href = URL.createObjectURL(response.data);
              // create "a" HTLM element with href to file & click
              const link = document.createElement("a");
              link.href = href;
              const current_datetime = new Date();
              const formatted_date =
                current_datetime.getFullYear() +
                "-" +
                (current_datetime.getMonth() + 1) +
                "-" +
                current_datetime.getDate() +
                " " +
                current_datetime.getHours() +
                "-" +
                current_datetime.getMinutes() +
                "-" +
                current_datetime.getSeconds();
              link.setAttribute(
                "download",
                "suppliers_" + formatted_date + ".xlsx"
              );
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    triggerResetPasswordModal(item) {
      this.userInfo.id = item.id;
      this.userInfo.name = item.name_cn;
      this.userInfo.password = "";
      this.userInfo.password_confirmation = "";
      this.$bvModal.show("modal-reset-staff-password");
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("supplier/deleteSupplier", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "supplier";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, supplierStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchSuppliers,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      suppliersList,
      refSupplierListTable,
      refetchData,
      ability,
    } = useSuppliersList();

    return {
      fetchSuppliers,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      suppliersList,
      refSupplierListTable,
      refetchData,
      ability,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 100px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";

.supplier-list-wrapper {
  .sticky-column {
    &:nth-child(2) {
      width: 175px !important;
      min-width: 175px !important;
      max-width: 175px !important;
    }
    &:nth-child(3) {
      left: 295px;
    }
  }
}
</style>
    